import {
  AUTH_SIGN_OUT,
  AUTH_SIGN_IN_SUCCESS,
  AUTH_RESET_PASSWORD_SUCCESS,
  AUTH_RESET_PASSWORD_REQUEST_SUCCESS
} from '../actions/authActions';

const initialState = {
  first_name: null,
  is_authenticated: false,
  token: null,
  password_changed: false,
  password_request_initiated: false,
  user_id: null,
  email: null,
  account_type: null
};

export default function (state = initialState, action) {
  switch (action.type) {
    case AUTH_SIGN_IN_SUCCESS:
      return {...state, ...action.payload};
    case AUTH_RESET_PASSWORD_SUCCESS:
      return {...state, ...action.payload};
    case AUTH_RESET_PASSWORD_REQUEST_SUCCESS:
      return {...state, password_request_initiated: action.payload};
    case AUTH_SIGN_OUT:
      return {...state, is_authenticated: false};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/authReducer.js